export default "__VITE_ASSET__CDD2e2Eh__"